import React from 'react';
import styles from './SpecialPublicationPreAccessBannerStyles.scss';

type SpecialPublicationPreAccessBannerProps = {
  backgroundImage: string;
  headlineText: string;
};

const SpecialPublicationPreAccessBanner: React.FunctionComponent<SpecialPublicationPreAccessBannerProps> = ({
  backgroundImage,
  headlineText
}): React.ReactElement => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
    >
      <div className={styles.headlineTextContainer}>
        <h5 className={styles.headlineText}>{headlineText}</h5>
        <div className={styles.headlineTextBackground} />
      </div>
    </div>
  );
};

export default SpecialPublicationPreAccessBanner;
